import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import './index.scss';

// A hover note that follows the mouse (antd's Tooltip stays pinned beside the word) and takes the page's palette colours.
// Near the window's right or bottom edge it flips to the other side of the cursor so it stays on screen.
const GAP = 16;
const WIDTH = 340;

const FollowTooltip: React.FC<{ title: React.ReactNode, children: React.ReactNode }> = ({ title, children }) => {
  const [pos, setPos] = useState<{ x: number, y: number } | null>(null);
  const move = (e: React.MouseEvent) => setPos({ x: e.clientX, y: e.clientY });

  let style: React.CSSProperties = {};
  if (pos) {
    const flipX = pos.x + GAP + WIDTH > window.innerWidth - 8;
    const flipY = pos.y > window.innerHeight * 0.6;
    style = {
      left: flipX ? Math.max(8, pos.x - GAP - WIDTH) : pos.x + GAP,
      ...(flipY ? { bottom: window.innerHeight - pos.y + GAP } : { top: pos.y + GAP }),
    };
  }

  return (
    <>
      <span className='tooltip' onMouseEnter={move} onMouseMove={move} onMouseLeave={() => setPos(null)}>{children}</span>
      {pos && createPortal(<div className='follow-tooltip' role='tooltip' style={style}>{title}</div>, document.body)}
    </>
  );
};

export default FollowTooltip;
